import { useLocation, useNavigate } from "react-router-dom";
import { useEffect } from 'react';

const CleanupUrl = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        if(location.search.includes('code=')) {
            navigate(location.pathname, {replace: true});
        } 
    }, [location, navigate]);

    return null;
}

export default CleanupUrl;